module.exports = __webpack_public_path__ + "static/media/ic-actions-calendar.adb6ecf4.svg";